import React from "react";
import styles from "./dashboard.module.css";
import SuperAdminDashboard from "./components/super-admin-dashboard/super-admin-dashboard";
import { useSelector } from "react-redux";
import AdminDashboard from "./components/admin-dashboard/admin-dashboard";

const Dashboard = () => {
  const user = useSelector((state) => state.user?.user);  
  return (
    <div className={styles.dashboard} data-testid="dashboard">
      {user?.role === 'ADMIN' ?<AdminDashboard/> :<SuperAdminDashboard />}
    </div>
  );
};

export default Dashboard;
